import uploader from "@/components/Common/ImgUploader/ImgUploader.vue";

const ImgUploader = {
  install: function (Vue) {
    Vue.component('imgUploader', uploader);
  }
}
export default ImgUploader;